import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../auth/useAuth';
import { generalInfoQuery, scenarioLevelsQuery, scenarioLevelsItemsViewQuery } from './api';
import Game from './index';
import GameScramble from './scramble';

export default function NormalRouter() {
  const params = useParams();
  const levelNumber = Number(params.levelNumber);
  
  const { getCurrentNormalGameId } = useAuth();
  const gameId = getCurrentNormalGameId();

  const { data: generalInfo, isLoading: generalInfoLoading } = useQuery(generalInfoQuery());
  const games = generalInfo?.games;

  const game = games?.find(g => g.game_type.includes('Normal Balance') && g.id === gameId);
  const scenarioId = game?.scenario;

  const { data: scenarioLevels, isLoading: levelsLoading } = useQuery({
    ...scenarioLevelsQuery({ scenarioId }),
    enabled: !!scenarioId,
  });

  const { data: answerData, isLoading: answerDataLoading } = useQuery({
    ...scenarioLevelsItemsViewQuery(scenarioId),
    enabled: !!scenarioId,
  });

  if (generalInfoLoading || !scenarioId || levelsLoading || answerDataLoading) {
    return null;
  }

  const currentLevel = scenarioLevels?.find(scenarioLevel => scenarioLevel.level === levelNumber);

  if (!currentLevel) {
    console.warn(`Level ${levelNumber} not found in scenarioLevels`);
    return <Game levelNumber={levelNumber} scenarioLevels={scenarioLevels} scenarioId={scenarioId} answerData={answerData} />;
  }

  const isScrambleLevel = currentLevel?.name?.toLowerCase().includes('scramble');

  if (isScrambleLevel) {
    return <GameScramble key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} scenarioId={scenarioId} />;
  }

  return <Game key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} scenarioId={scenarioId} answerData={answerData} />;
}